// Axis groups: registers sharing the same group share a y-axis (title/range).
// The "default" group is used for any register that is not explicitly grouped.
export type AxisGroup = { title: string; range?: [number, number] };

export const AXIS_GROUPS: Record<string, AxisGroup> = {
    temperature: { title: "Temperature", range: [0, 30] },
    c2h4: { title: "C₂H₄ (ppm)", range: [0, 400] },
    o2: { title: "O₂ (%)", range: [0, 25] },
    co2: { title: "CO₂ (%)", range: [0, 15] },
    color_score: { title: "Color score", range: [0, 7] },
    default: { title: "Value" },
};

// Order = priority for becoming the *primary* axis ("y"). Plotly requires at
// least one trace on "y", so the first group that actually has data wins.
export const AXIS_GROUP_PRIORITY: string[] = ["temperature", "c2h4", "o2", "co2", "color_score", "default"];

// Resolves the group for a register key by prefix (e.g. "color_score_chiquita_1c").
export const getAxisGroupKey = (registerKey: string): string | undefined => (
    AXIS_GROUP_PRIORITY.find((group) => group !== "default" && registerKey.startsWith(group))
);
